import { getCurrentTier, getHarmonyMultiplier, HARMONY_CONFIG, PATIENCE_CONFIG, RHYTHM_CONFIG } from '../config/streaks';

export interface StreakState {
  harmony: number;
  patience: number;
  rhythm: number;
  shields: number;
}

export class Streaks {
  private harmony = 0;
  private patience = 0;
  private rhythm = 0;
  private shields = 0;

  constructor(state?: StreakState) {
    if (state) {
      this.harmony = state.harmony;
      this.patience = state.patience;
      this.rhythm = state.rhythm;
      this.shields = state.shields;
    }
  }

  getState(): StreakState {
    return {
      harmony: this.harmony,
      patience: this.patience,
      rhythm: this.rhythm,
      shields: this.shields,
    };
  }

  getHarmony(): number { return this.harmony; }
  getPatience(): number { return this.patience; }
  getRhythm(): number { return this.rhythm; }
  getShields(): number { return this.shields; }

  getHarmonyTier(): number { return getCurrentTier(this.harmony, HARMONY_CONFIG); }
  getPatienceTier(): number { return getCurrentTier(this.patience, PATIENCE_CONFIG); }
  getRhythmTier(): number { return getCurrentTier(this.rhythm, RHYTHM_CONFIG); }

  getMultiplier(): number {
    return getHarmonyMultiplier(this.harmony);
  }

  onPlacement(producedClear: boolean): { harmonyBroke: boolean; patienceBroke: boolean; rhythmBroke: boolean; patienceAtBreak: number; rhythmAtBreak: number } {
    const result = { harmonyBroke: false, patienceBroke: false, rhythmBroke: false, patienceAtBreak: 0, rhythmAtBreak: 0 };

    this.harmony++;

    if (producedClear) {
      result.patienceAtBreak = this.patience;
      result.patienceBroke = this.patience >= PATIENCE_CONFIG.tiers[0].threshold;
      this.patience = 0;
      this.rhythm++;
    } else {
      this.patience++;
      result.rhythmAtBreak = this.rhythm;
      result.rhythmBroke = this.rhythm >= RHYTHM_CONFIG.tiers[0].threshold;
      this.rhythm = 0;
    }

    return result;
  }

  onDiscard(): { harmonyAtBreak: number } {
    const harmonyAtBreak = this.harmony;
    this.harmony = 0;
    return { harmonyAtBreak };
  }

  addShields(count: number): void {
    this.shields += count;
  }

  consumeShield(): boolean {
    if (this.shields <= 0) return false;
    this.shields--;
    return true;
  }
}
